import React, { useState, useLayoutEffect, useCallback } from "react";

import { ICON_DOWNLOAD_SIZE } from "core/localStorageKeys";
import { getLocalStorage, setLocalStorage } from "js/helpers/functions";
import { BASIC_DOWNLOAD_SIZE, DEFAULT_DOWNLOAD_SIZE } from "icons/helpers";

// Persist the download size in local-storage.
// If the download type is basic, return the basic download size and block updates.
const useIconDownloadSize = ({ isBasic = false } = {}) => {
    const defaultSize = isBasic ? BASIC_DOWNLOAD_SIZE : DEFAULT_DOWNLOAD_SIZE;
    const [downloadSize, setDownloadSize] = useState(defaultSize);

    useLayoutEffect(() => {
        if (!isBasic) {
            const lastSize = getLocalStorage(ICON_DOWNLOAD_SIZE);
            if (lastSize && lastSize !== downloadSize) {
                setDownloadSize(lastSize);
            }
        }
    }, []);

    // memoize the setter function
    const saveDownloadSize = useCallback(size => {
        if (!isBasic) {
            setLocalStorage(ICON_DOWNLOAD_SIZE, size);
            setDownloadSize(size);
        }
    }, []);

    return [downloadSize, saveDownloadSize];
};

export default useIconDownloadSize;
